import { connect } from "react-redux";
import { gangDetectionAction } from "../../_actions/gang.detection.actions";
import React from "react";
import { Button, PageHeader } from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import { GangList } from "./gangLIst";
import moment from "moment";
import * as XLSX from "xlsx-js-style";
import _ from "lodash";
import { professionalAction } from "../../_actions";

class GangReport extends React.Component {
  static contextType = LanguageContext;
  state = {
    list: [],
    loading: false,
    page: 0,
    size: 10,
  };

  getGangPaginate = () => {
    this.setState({ loading: true });
    let body = {
      page: 1,
    };
    gangDetectionAction.getGangPaginate(body).then((res) => {
      this.setState({
        list: res?.data.gangs,
        loading: false,
      });
    });
  };
  componentDidMount = () => {
    this.props.dispatch(professionalAction.getCity());
    this.getGangPaginate();
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_csv = () => {
    const { t, language } = this.context;
    const { showList, filter } = this.state;
    const report_name = t("gang_detection");

    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;

    let ReportTitle = "";

    let list1 = [];

    list1 =
      this.state.list &&
      this.state.list.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("gang_name")]: data.gang_name,
        [t("last_update")]: moment(data.updated_at).format("DD-MM-YYYY"),
      }));

    var arrData = list1;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length)
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    const cellStyle = {
      font: { sz: 12 },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };
    Object.keys(arrData[0]).forEach((key, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: index }); // Headers are at row 3 (A3)
      if (!ws[cellRef]) ws[cellRef] = {}; // Ensure cell exists
      ws[cellRef].s = headerStyle;
    });
    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((value, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        }); // Data starts at row 4
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].s = cellStyle;
      });
    });

    ws["A1"] = {
      v: this.getCityName(this.props?.user?.cityId || ""),
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };
    console.log("language", language);
    if (this.state.report_type !== "history_sheeter") {
      ws["A3"] = {
        v: `${t("from")} ${moment(this.state.report_4_startDate).format(
          "DD-MM-YYYY"
        )} - ${t("to")} ${moment(this.state.report_4_endDate).format(
          "DD-MM-YYYY"
        )}`,
        t: "s",
        s: headerStyle,
      };
    }

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY"
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    mergeRanges.push({
      s: { r: 2, c: 0 },
      e: { r: 2, c: columnWidths.length - 1 },
    });

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  render() {
    const { t } = this.context;
    const { list } = this.state;
    console.log("this.state.list", this.state.list);
    return (
      <>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              title={t("gang_detection")}
              extra={[
                <Button
                  type="primary"
                  onClick={() => this.download_csv()}
                  disabled={!this.state.list?.length}
                  key="download"
                >
                  Download Excel
                </Button>,
              ]}
            />
          </div>
        </div>
        <React.Suspense fallback={<div>Loading...</div>}>
          <GangList
            data={list}
            user={this.props.user}
            getGangPaginate={this.getGangPaginate}
            loading={this.state.loading}
          />
        </React.Suspense>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const {
    pc_cities,
    basicDistricts,
    pc_status,
    pc_crimetitles,
    pc_crimetypes,
    pc_countrystates,
  } = professionals;
  return {
    user,
    users,
    professionals,
    basicDistricts,
  };
}

const connectedGangReport = connect(mapStateToProps)(GangReport);
export { connectedGangReport as GangReport };
